import { toSnakeCase } from './object-to-form-data'

const convertKeysToSnakeCase = (object: any): any => {
  if (object === null || object === undefined) {
    return object
  }

  if (Array.isArray(object)) {
    return object.map((item) => convertKeysToSnakeCase(item))
  } else if (object !== null && object.constructor === Object) {
    return Object.keys(object).reduce(
      (result, key) => {
        result[toSnakeCase(key)] = convertKeysToSnakeCase(object[key])
        return result
      },
      {} as Record<string, any>
    )
  }
  return object
}

export const objectToJsonString = (object: Record<string, any>): string => {
  const snakeCaseObj = convertKeysToSnakeCase(object)
  return JSON.stringify(snakeCaseObj)
}
